import { render, staticRenderFns } from "./embody.vue?vue&type=template&id=364ea188&"
import script from "./embody.vue?vue&type=script&lang=js&"
export * from "./embody.vue?vue&type=script&lang=js&"
import style0 from "./embody.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports